import { render, staticRenderFns } from "./UserProfilepicture.vue?vue&type=template&id=4023705e&scoped=true"
import script from "./UserProfilepicture.vue?vue&type=script&lang=js"
export * from "./UserProfilepicture.vue?vue&type=script&lang=js"
import style0 from "./UserProfilepicture.vue?vue&type=style&index=0&id=4023705e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4023705e",
  null
  
)

export default component.exports